import React from 'react';
import { Breadcrumbs } from '../../../library/common/components';
import { routes } from '../../../main/routes';
import before from '../../../resources/img/before.jpg';
import after from '../../../resources/img/after.jpg';

const projectType = (id) => {
  switch (id) {
    case '2':
      return 'Instalación de Suelos';
		case '3':
			return 'Reforma Cocina';
		case '4':
			return 'Reforma Baño';
		case '5':
			return 'Instalación de Calefaccion';
		case '6':
			return 'Instalación de Ventanas';
		case '7':
			return 'Pintado de piso';
		case '8':
			return 'Instalación electrica';
    default:
      return 'Reforma Integral';
  }
}

const Project = (props) => {
  const crumbs = routes
    .filter(({ path }) => props.match.path.includes(path))
    .map(({ path, ...rest }) => ({
      path: Object.keys(props.match.params).length
        ? Object.keys(props.match.params).reduce(
          (path, param) => path.replace(
            `:${param}`, props.match.params[param]
          ), path
          )
        : path,
      ...rest
    }));

  return (
  <div className='single-project'>
    <Breadcrumbs crumbs={crumbs} title={projectType(props.match.params.id)}/>
		<div className='body content'>
			<div className='column-left'>
				<div className='description'>
					<span className='title'>Información general</span>
					<span><strong>Cliente:</strong>Yellow Hats</span>
					<span><strong>Location:</strong>Tanta, Algharbia</span>
					<span><strong>Gross Building Area:</strong>Approx: 330,000 m2</span>
					<span><strong>Project started:</strong>2016 / March</span>
					<span><strong>Project complited:</strong>2017 / September</span>
					<span><strong>Architect:</strong>Begha</span>
					<span><strong>Category:</strong>Building, Commercial</span>
					<span><strong>Value:</strong>$ 2 250 000</span>
				</div>
				<div className='info'>
					<span className='title'>Descripción del proyecto</span>
					<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
				</div>
			</div>
			<div className='column-right'>
				<div>
					<img src={before} />
					<span className='type'>Antes</span>
				</div>
				<div>
					<img src={after} />
					<span className='type'>Después</span>
				</div>
			</div>
		</div>
  </div>
)};

export default Project;
